import React, { useEffect, useRef, useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from "../components/Footer";
import acqua from '../assets/trattamenti/VIDEO-MCARE.mp4';
import { ScrollParallax } from 'react-just-parallax';
import iconAmbulance from '../assets/icon/ambulance.png';
import iconBed from '../assets/icon/hospital_bed.png';
import iconReport from '../assets/icon/medical_report.png';
import iconInjury from '../assets/icon/injury.png';
import imageTesta from '../assets/trattamenti/testa-collo.jpg';
import imageSpalle from '../assets/trattamenti/spalla.jpg';
import imageGinocchio from '../assets/trattamenti/ginocchio.jpg';
import imageAnca from '../assets/trattamenti/anca.jpg';
import imagePiede from '../assets/trattamenti/Piede-caviglia.jpg';
import imageSchiena from '../assets/trattamenti/schiena.jpg';
import SwiperImage from '../components/SwiperImage';
import big1 from '../assets/azienda/sede-mcare.png';
import ContactForm from '../components/contactForm/ContactForm';
import CallButton from '../components/CallButton';
import logoShort from "../assets/logo/logo.png";
import { useIntersectionObserver } from '../components/Observer';
import { Helmet } from "react-helmet";
import HumanBody from '../components/3dModel/HumanBody'; 
import { useNavigate } from 'react-router-dom';
import TextTransition, { presets } from 'react-text-transition';
import LogoAnimation from '../components/logo/logoAnimation';
import TecnologieImg from '../assets/tecnologie/the-procedure-of-myo.jpg'
import ContactModal from '../components/ContactModal';
import img3 from '../assets/trattamenti/fisioterapia.jpg';
import player from '../assets/Servizi/player-reversed.jpg';


const TEXTS = ['Professionalità', 'Tempestività', 'Innovazione'];


function HomePage() {
  const refTesta = useRef(null);
  const refSpalle = useRef(null);
  const refGinocchio = useRef(null);
  const refAnca = useRef(null);
  const refCaviglia = useRef(null);
  const refSchiena = useRef(null);
  const refPaolo = useRef(null);
  const refLuca = useRef(null);
  const refMartin = useRef(null);
  const [contactModal, setContactModal] = useState(false);
  const [index, setIndex] = React.useState(0);
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  

  React.useEffect(() => {
    const intervalId = setInterval(
      () => setIndex((index) => index + 1),
      2500, // every 3 seconds
    );
    return () => clearTimeout(intervalId);
  }, []);


  const options = {
    root: null,
    threshold: 0.5,
    rootMargin: "-95px"
  };

  useIntersectionObserver(refTesta, options);
  useIntersectionObserver(refSpalle, options);
  useIntersectionObserver(refGinocchio, options);
  useIntersectionObserver(refAnca, options);
  useIntersectionObserver(refCaviglia, options);
  useIntersectionObserver(refSchiena, options);
  useIntersectionObserver(refPaolo, options);
  useIntersectionObserver(refLuca, options);
  useIntersectionObserver(refMartin, options);

  const navigate = useNavigate();


  const handleClickForm = () => {
    const element = document.querySelector('#formContatti');
    element.scrollIntoView({ behavior: 'smooth' });
  };

  const openContactModal = () => {
    setContactModal(true);
  };

  const closeContactModal = () => {
    setContactModal(false);
  };
 

  function animateConsoleLog() {
    const styles = [
      'font-size: 20px; font-weight: bold; color: #ff007f',
      'font-size: 40px; font-weight: bold; color: #ff007f',
      'font-size: 60px; font-weight: bold; color: #ff007f',
      'font-size: 80px; font-weight: bold; color: #ff007f',
      'font-size: 100px; font-weight: bold; color: #ff007f',
      'font-size: 80px; font-weight: bold; color: #ff007f',
      'font-size: 60px; font-weight: bold; color: #ff007f',
      'font-size: 40px; font-weight: bold; color: #ff007f',
      'font-size: 20px; font-weight: bold; color: #ff007f'
    ];
  
    let index = 0;
    const intervalTime = 100; // Interval time in milliseconds
    const duration = 5000; // Duration for the animation in milliseconds
  
    const intervalId = setInterval(() => {
      console.log('%c ciao! ', styles[index]);
      index = (index + 1) % styles.length;
    }, intervalTime);
  
    setTimeout(() => {
      clearInterval(intervalId);
    }, duration);
  }

  function goToPage(pageName) {
    navigate(pageName)
  }

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  

  return (
    <>
      <Helmet>
        <title>Centro di Riabilitazione e Performance a Verona | MCARE</title>
        <meta name="description" content="MCARE è un centro di riabilitazione situato alle porte di Verona. Offriamo trattamenti personalizzati per recupero post-infortunio, post-chirurgico, e gestione del dolore cronico. Prenota una visita oggi stesso!" />
        <meta name="keywords" content="centro di riabilitazione Verona, riabilitazione sportiva, fisioterapia Verona, recupero post-operatorio, trattamento dolore cronico, riabilitazione personalizzata, fisioterapisti esperti, MCARE Verona" />
        <meta property="og:title" content="Centro di Riabilitazione e Performance a Verona | MCARE" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://mcarefisio.it" />
        <meta property="og:image" content="https://mcarefisio.it/static/media/logo2.47585272f37641121cdd.png" />
        <meta property="og:description" content="MCARE è un centro di riabilitazione situato alle porte di Verona. Offriamo trattamenti personalizzati per recupero post-infortunio, post-chirurgico, e gestione del dolore cronico. Prenota una visita oggi stesso!" />
        <meta property="og:site_name" content="mcare" />
        <meta property="og:locale" content="it_IT" />
      </Helmet>

      <div className="" data-aos="fade-in" data-aos-duration="2000">
        <Navbar />
        {/* HERO SECTION */}
        <section>
          <div className='mx-auto'>
            <div className='h-screen flex justify-center items-center relative'>
              {/* <div className='h-full w-full sm:w-3/4 xl:w-1/2 flex justify-center items-center p-4 z-20'>
                <div className='text-left w-full xl:max-w-3xl mx-auto mb-36 xl:mb-14 sm:mb-0'>
                  <LogoAnimation percentage={width < 420 ? 100 : 125}/>
                  <div className="flex justify-start items-center w-full me-0 sme-2">
                    <h1 className={`text-3xl xl:text-4xl text-slate-50 font-medium`} data-aos="fade-right" data-aos-duration="2000">Dove la Riabilitazione  diventa Performance</h1>          
                  </div>
                  <div data-aos="fade-right" data-aos-duration="2500" className='mb-10 mt-5 font-medium xl:ms-4 sm:ms-0 text-white text-balance'>
                    <p className='font-normal text-xl xl:text-2xl'>Diamo nuova Vita al tuo Movimento</p>
                  </div>
                  <button onClick={handleClickForm} id='heroSection' className={`px-8 py-2 w-full xl:w-2/3  progress-button-mcare sm:text-white md:text-white lg:text-white`}>Prenota una consulenza</button>
                </div>
              </div>   */}
                  {/* Video Background */}
                    <video
                      autoPlay
                      loop
                      muted
                      playsInline
                      className="absolute object-right w-full h-full object-cover -z-10 opacity-30 xl:hidden block"
                      src={acqua}
                      type="video/mp4"
                    ></video>

                  <div className="relative h-full w-full sm:w-3/4 xl:w-1/2 flex justify-center items-center p-4 z-20">

                    {/* Content */}
                    <div className="text-left w-full xl:max-w-3xl mx-auto mb-36 xl:mb-14 sm:mb-0 z-20 xl:pl-28">
                      <LogoAnimation percentage={width < 420 ? 100 : 125} />
                      <div className="flex justify-start items-center w-full me-0 sme-2">
                        <h1
                          className="text-3xl xl:text-4xl text-slate-50 font-medium"
                          data-aos="fade-right"
                          data-aos-duration="2000"
                        >
                          Dove la Riabilitazione diventa Performance
                        </h1>
                      </div>
                      <div
                        data-aos="fade-right"
                        data-aos-duration="2500"
                        className="mb-10 mt-5 font-medium sm:ms-0 text-white text-balance"
                      >
                        <p className="font-normal text-xl xl:text-2xl">
                          Diamo nuova Vita al tuo Movimento
                        </p>
                      </div>
                      <button
                        onClick={handleClickForm}
                        id="heroSection"
                        className="px-8 py-2 w-full xl:w-2/3 progress-button-mcare sm:text-white md:text-white lg:text-white"
                      >
                        Prenota una consulenza
                      </button>
                    </div>
                  </div>
              <div className='opacity-80 h-full hidden xl:block sm:w-1/2 z-0 relative'>
                <video
                  autoPlay
                  loop
                  muted
                  playsInline
                  className="h-full ms-auto object-cover lg:opacity-90 opacity-50"
                  style={{ transform: 'scale(1)' }}
                  alt="background video">
                  <source src={acqua} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
                {/* <img src={headerImage} alt='La scelta responsabile per il tuo futuro' className='w-full h-full object-cover' /> */}
                <svg className="absolute inset-y-0 left-0 w-[11.5rem] h-full" viewBox="0 0 100 100" preserveAspectRatio="none">
                  <polygon points="0,0 100,0 0,100" fill="currentColor" />
                </svg>
              </div>  
            </div>
          </div>
        </section>


        {/* sez. come possiamo aiutarti? */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-10 pb-10 pt-10 lg:px-0 px-5 bg-neutral-100">
          <div className="col-span-2 lg:col-span-4 text-center">
            <p className='text-black font-semibold text-4xl my-10 text-mcare panoragraf-light'>Come possiamo aiutarti?</p>
          </div>
          <div className="col-span-2 flex justify-center cursor-pointer lg:justify-end items-center" onClick={openContactModal}>
            <p className="text-black text-start text-xl font-semibold me-4 w-[25rem] pl-4">Mi sono appena infortunato</p>
            <img src={iconAmbulance} className="w-11" alt='Ambulance'/>
          </div>
          <div className="col-span-2 flex justify-center cursor-pointer lg:justify-start items-center " onClick={openContactModal}>
            <p className="text-black text-start text-xl font-semibold me-4 w-[25rem] pl-4">Ho subito un intervento chirurgico</p>
            <img src={iconBed} className="w-11" alt='Bed'/>
          </div>
          <div className="col-span-2 flex justify-center cursor-pointer lg:justify-end items-center" onClick={openContactModal}>
            <p className="text-black text-start text-xl font-semibold me-4 w-[25rem] pl-4">Mi hanno prescritto queste cure</p>
            <img src={iconReport} className="w-11" alt='Report'/>
          </div>
          <div className="col-span-2 flex justify-center cursor-pointer lg:justify-start items-center" onClick={openContactModal}>
            <p className="text-black text-start text-xl font-semibold me-4 w-[25rem] pl-4">Soffro da tempo di...</p>
            <img src={iconInjury} className="w-11" alt='Injury'/>
          </div>
        </div>
      </div>
      {/* SEZ TRATTAMENTI MOBILE */}
      <div className="grid grid-cols-4 gap-2 pb-20 bg-black xl:bg-neutral-100 pt-16">
        <div className="col-span-4 text-center">
          <p className='font-semibold text-4xl my-10 panoragraf-light' style={{"color":"#65806E"}}>Trattamenti personalizzati</p>
        </div>
        <div className="col-span-4 flex justify-center items-center">
            <p className="text-white xl:text-black text-center text text-xl px-5 xl:px-60"><strong>MCARE</strong> non è solo un centro di riabilitazione, ma un partner affidabile nel percorso di recupero e <em className='font-bold'>miglioramento della qualità di vita.</em></p>
        </div>
      </div>
      {/* section images treatment */}
      <div className="grid grid-cols-6 gap-10 px-0 md:px-40 lg:px-[30%] xl:px-0 2xl:px-32 block xl:hidden">
        {/* prima parte */}
        <div className="col-span-6 xl:col-span-2 relative overflow-hidden">
          <figure ref={refTesta} className="effect-apollo">
            <img src={imageTesta} className='w-full' alt="Testa/Collo"/>
            <figcaption onClick={() => goToPage('/testa-collo/')}>
              <h2 className='text-start font-bold uppercase'>Testa/Collo</h2>
              <p>Dolore cervicale, ernie cervicali, post intervento chirurgico, terapia post colpo di frusta, cefalee, quadri vertiginosi, problematiche temporo-mandibolari (ATM).</p>
              <button onClick={handleClickForm}></button>
            </figcaption>
          </figure>
        </div>
          <div ref={refSpalle} className="col-span-6 xl:col-span-2 relative overflow-hidden">
            <figure className="effect-apollo">
              <img src={imageSpalle} className='w-full' alt="img22" />
              <figcaption  onClick={() => goToPage('/spalla/')}>
                <h2 className='text-start font-bold uppercase'>Spalle</h2>
                <p>Tendinopatie, lussazioni, lesioni della cuffia dei rotatori, spalla congelata.</p>
                <button onClick={handleClickForm}></button>
              </figcaption>
            </figure>
          </div>
          <div ref={refGinocchio} className="col-span-6 xl:col-span-2 relative overflow-hidden">
            <figure className="effect-apollo">
              <img src={imageGinocchio} className='w-full' alt="img22" />
              <figcaption onClick={() => goToPage('/ginocchio/')}>
                <h2 className='text-start font-bold uppercase'>Ginocchio</h2>
                <p>Lesioni legamentose, sindrome femoro-rotulea, tendinopatie.</p>
                <button onClick={handleClickForm}></button>
              </figcaption>
            </figure>
          </div>
        </div>
        <div className="col-span-3 relative flex justify-center overflow-hidden my-16 block xl:hidden">
            <p className="text-slate-50 text-center text text-xl px-5 lg:px-52"><strong>MCARE</strong> rappresenta la soluzione nella riabilitazione fisica e sportiva. Situato alle porte di Verona, il nostro centro si distingue per l'uso di tecniche all'avanguardia e un team di specialisti dedicati, che operano in un ambiente moderno e confortevole.</p>
        </div>
        {/* seconda parte */}
        <div className="grid grid-cols-6 gap-10 pb-10 px-0 md:px-40 lg:px-[30%] xl:px-0 2xl:px-32 block xl:hidden">
          <div ref={refAnca} className="col-span-6 xl:col-span-2 relative overflow-hidden">
            <figure className="effect-apollo">
              <img src={imageAnca} className='w-full' alt="img22" />
              <figcaption onClick={() => goToPage('/anca-bacino/')}>
                <h2 className='text-start font-bold uppercase'>Anca/Bacino</h2>
                <p>Impingement femoro-acetabolare, tendinopatie, fratture, protesi dell'anca.</p>
                <button onClick={handleClickForm}></button>
              </figcaption>
            </figure>
          </div>
          <div ref={refCaviglia} className="col-span-6 xl:col-span-2 relative overflow-hidden">
            <figure className="effect-apollo">
              <img src={imagePiede} className='w-full' alt="img22" />
              <figcaption onClick={() => goToPage('/caviglia-piede/')}>
                <h2 className='text-start font-bold uppercase'>Caviglia e Piede</h2>
                <p>Distorsioni, fascite plantare, tendinopatie, lesioni osteocondrali.</p>
                <button onClick={handleClickForm}></button>
              </figcaption>
            </figure>
          </div>
          <div ref={refSchiena} className="col-span-6 xl:col-span-2 relative overflow-hidden">
            <figure className="effect-apollo">
              <img src={imageSchiena} className='w-full' alt="img22" />
              <figcaption onClick={() => goToPage('/schiena/')}>
                <h2 className='text-start font-bold uppercase'>Schiena</h2>
                <p>Lombalgia, ernia del disco, stenosi, spondilolistesi.</p>
                <button onClick={handleClickForm}></button>
              </figcaption>
            </figure>
          </div>
        </div>

{/* SEZ TRATTAMENTI DESKTOP */}
        {<div className='hidden xl:block'>
          <HumanBody prenota={handleClickForm}/>
        </div>}

{/* SEZ. LE NOSTRE TECNOLOGIE */}
        <div className='relative z-20 h-lvh overflow-hidden'>
          <ScrollParallax enableOnTouchDevice={true} isAbsolutelyPositioned={true} lerpEase="0.05">
              <img src={TecnologieImg} alt='Tecnologie' className="absolute top-0 left-0 w-full h-full object-cover" style={{ transform: 'scale(1.2)' }} />
          </ScrollParallax>
          <div className="absolute top-0 left-0 lg:bg-black lg:bg-opacity-60 bg-white w-full h-full flex justify-center items-center">
              {/* Text container centered and slightly moved to the right */}
              <div className="flex justify-end text-start ps-15  mx-[5%] md:ml-[5%]">
                <div className='lg:w-[50%]'>
                  <h2 className="lg:text-5xl text-4xl lg:text-[#65806E] font-semibold drop-shadow-lg text-balance" data-aos="fade-up" data-aos-duration="1000">
                  Le nostre tecnologie
                  </h2>
                  <p className="text-xl mt-4 mb-10 lg:text-white drop-shadow-lg text-balance" data-aos="fade-up" data-aos-duration="1000">
                  Presso il nostro centro di fisioterapia, abbracciamo l'innovazione utilizzando le più recenti tecnologie per garantire ai nostri pazienti esperienze di riabilitazione avanzate e personalizzate.
                  </p>
                  <a href='/tecnologie/' >
                    <button className={`progress-button-mcare progress-button-mcare-black px-8 py-2 text-center w-full lg:w-1/2`}>
                      SCOPRI DI PIÙ
                    </button>
                  </a>
                </div>
              </div>
          </div>
      </div>

{/* SEZ. MCARE IN 3 PAROLE */}
      <div className={`relative z-21 h-lvh overflow-hidden flex justify-center items-center lg:bg-mcare`}>
          <div className={`w-full h-full flex`}>
            <div className={`absolute lg:relative flex flex-col justify-center items-start text-left z-10 px-10 2xl:px-32 xl:w-3/5 w-full translate-y-16 lg:translate-y-0`}>
              <img src={logoShort} alt="Company Logo" className="pb-2 sm:mb-0 sm:me-10 w-1/4" />
              <hr className="border-b-3 border border-[#65806E] bg-[#65806E] w-20 mt-5 h-0.5" />
              <div className='text-xl text-white flex flex-col xl:flex-row justify-start mt-10 mb-5'>
                <p className='font-medium'>Le nostre parole chiave sono </p>
                <TextTransition className='uppercase py-5 xl:py-0 xl:ps-2 lg:text-4xl text-3xl xl:-mt-3' springConfig={presets.wobbly}>{TEXTS[index % TEXTS.length]}</TextTransition>
              </div>
              <div className={`text-md xl:text-lg text-md mt-4 mb-10 text-slate-50`} data-aos="fade-up" data-aos-duration="1000">
                MCARE nasce dalla passione e dall’impegno dei nostri fisioterapisti, che vantano un’esperienza pluriennale nella gestione di pazienti con disturbi muscolo-scheletrici. La filosofia di MCARE è mettere <em>la persona al centro</em> del percorso terapeutico:<br /> per questo, ogni piano di cura è personalizzato in base alle esigenze del singolo paziente.
              </div>
              <button onClick={handleClickForm} rel='noopener noreferrer' className={`px-8 py-2 progress-button-mcare `}>Scopri di più</button>
            </div>
            <div className={`relative overflow-hidden flex justify-start items-center opacity-60 xl:w-2/5 w-full`}>
              <ScrollParallax enableOnTouchDevice={true} lerpEase="0.05" className="absolute inset-0">
                <img src={big1} className="h-full w-full object-right object-cover pe-1 opacity-60 lg:opacity-90" alt="background" style={{ transform: 'scale(1.2)' }} />
              </ScrollParallax>
            </div>
          </div>
      </div>

{/* SEZ STAFF/TEAM */}
      <div className='relative z-20 h-lvh overflow-hidden'>
          <ScrollParallax enableOnTouchDevice={true} isAbsolutelyPositioned={true} lerpEase="0.05">
              <img src={img3} alt='Staff' className="absolute top-0 left-0 w-full h-full object-cover" style={{ transform: 'scale(1.2)' }} />
          </ScrollParallax>
          <div className="absolute top-0 left-0 lg:bg-black lg:bg-opacity-50 bg-white w-full h-full flex justify-center items-center">
              {/* Text container centered and slightly moved to the right */}
              <div className="flex justify-end text-start ps-15  mx-[5%] md:ml-[5%]">
                <div className='lg:w-[50%]'>
                  <h2 className="lg:text-5xl text-4xl lg:text-[#65806E] font-semibold drop-shadow-lg text-balance" data-aos="fade-up" data-aos-duration="1000">
                  I nostri professionisti
                  </h2>
                  <p className="text-xl mt-4 mb-10 lg:text-white drop-shadow-lg text-balance" data-aos="fade-up" data-aos-duration="1000">
                  Presso il nostro centro di fisioterapia, abbracciamo l'innovazione utilizzando le più recenti tecnologie per garantire ai nostri pazienti esperienze di riabilitazione avanzate e personalizzate.
                  </p>
                  <a href='/staff' >
                    <button className={`progress-button-mcare progress-button-mcare-black px-8 py-2 text-center w-full lg:w-1/2`}>
                      SCOPRI DI PIÙ
                    </button>
                  </a>
                </div>
              </div>
          </div>
      </div>

      {/* PSICOLOGIA DELLO SPORT */}
      <div className='relative z-20 h-lvh overflow-hidden'>
          <ScrollParallax enableOnTouchDevice={true} isAbsolutelyPositioned={true} lerpEase="0.05">
              <img src={player} alt='Staff' className="absolute top-0 left-0 w-full h-full object-cover" />
          </ScrollParallax>
          <div className="absolute top-0 left-0 lg:bg-black lg:bg-opacity-50  w-full h-full flex justify-center items-center">
              <div className="flex text-start md:ml-[5%] ml-9 lg:mr-96 ">
                <div className='lg:w-[50%]'>
                  <h2 className="lg:text-5xl text-4xl text-[#65806E] font-semibold drop-shadow-lg text-balance" data-aos="fade-up" data-aos-duration="1000">
                  Psicologia dello sport
                  </h2>
                  <div className='lg:text-xl text-white drop-shadow-lg mr-1'  data-aos="fade-up" data-aos-duration="1000">
                    <p className=" mt-4 mb-10 text-balance lg:text-wrap">
                    Supporto psicologico personalizzato per affrontare sfide emotive, motivazionali e mentali durante la carriera sportiva.
                    </p>
                    <ul className="mt-8 font-semibold list-disc mb-10">
                      <li>
                        <span>Colloqui individuali</span>
                      </li>
                      <li>
                        <span>Mental Training post infortunio</span>
                      </li>
                      <li>
                        <span>Assessment psicologico</span>
                      </li>
                      <li>
                        <span>Tecniche di rilassamento e gestione dello stress</span>
                      </li>
                    </ul>
                  </div>
                  <a href='/servizi' >
                    <button className={`px-8 py-2 progress-button-mcare`}>
                      SCOPRI DI PIÙ
                    </button>
                  </a>
                </div>
              </div>
          </div>
      </div>




      {/* sez. I nostri professionisti */}
      {/* <div className="grid grid-cols-4 gap-2 py-10 bg-[#252F29]">
        <div className="col-span-4 text-center">
          <p className='text-slate-50 font-semibold text-4xl my-10 panoragraf-light'>I nostri professionisti</p>
        </div>
      </div>
      <div className="block px-0 sm:px-10 xl:px-40 pb-20 bg-[#252F29]">
        <PeopleSlider />
      </div> */}

      {/* sez. convenzioni */}
      <div className="grid grid-cols-4 gap-0" id='formContatti'>
        <div className="col-span-4 text-center bg-black z-20 mt-10">
          <p className='text-slate-50 font-bold text-4xl my-10 panoragraf-light' style={{"color":"#65806E"}}>Convenzioni</p>
        </div>
        <div className="col-span-4 flex justify-center items-center bg-black pb-10 z-20 ">
            <p className="text-slate-50 text-center text text-xl w-5/6 md:w-2/5 font-semibold"><em>Vantiamo convenzioni con molteplici realtà, ci occupiamo dell’intera gestione burocratica sollevandoti da qualsiasi scadenza e incombenza.</em></p>
        </div>
        <div className="col-span-4 flex justify-center items-center pb-32 bg-black">
          <div className="w-full absolute z-0" style={{"height":"120%"}}></div>
          <div className='w-full lg:w-2/6 z-40 px-5'>
            <p className='text-center text-4xl font-semibold text-mcare panoragraf-light'>Prenota una visita</p>
            <ContactForm 
              LandingName='mcare'
              Name={true}
              NameClass='text-slate-50'
              NameText='Nome e Cognome:'
              NameRequired={true}
              Tel={true}
              TelClass='text-slate-50'
              TelText='Telefono:'
              TelRequired={true}
              Email={true}
              EmailClass='text-slate-50'
              EmailText='Email:'
              EmailRequired={true}
              ConsensoDati={true}
              ConsensoDatiRequired={true}
              ConsensoDatiText='Consenso dati'
              ConsensoDatiID={1}
              ConsensoDatiClass='text-slate-50'
              successText='Messaggio inviato con successo!'  
              successLink='/'
              errorText='Si è verificato un errore, Riprova!'
              SendText='Invia'
              SendClass='progress-button-mcare w-full '
            />
          </div>
        </div>
      </div>
      <Footer />
      <CallButton />
      <ContactModal isContactModal={contactModal} closeModal={closeContactModal} />
    </>
  )
}

export default HomePage;
